import React from 'react'
import { makeStyles } from 'tss-react/mui'

interface Props {
  children?: React.ReactNode
}

const useStyles = makeStyles()(theme => ({
  spacing: {
    '& > button': {
      margin: theme.spacing(1),
    },
  },
}))

const StepButtonBar: React.FC<Props> = ({ children }) => {
  const { classes } = useStyles()
  return <div className={classes.spacing}>{children}</div>
}

export default StepButtonBar
